import { MouseEvent } from "react";
import { useRouter } from "next/router";
import { SearchQueryParams } from "src/components/pages/search/search.types";
import { ViewMode } from "src/components/pages/search/store/search-store";
import { loadViewMode } from "src/components/pages/search/store/search-view-local-storage";
import { getGlobals } from "src/constants/globals";

const isPlainLeftClick = (event: MouseEvent) => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

const getPathname = (url: string) => url.split("#")[0].split("?")[0];

export const useSearchViewModeLink = () => {
    const router = useRouter();

    const handleSearchLinkClick = (event: MouseEvent<HTMLElement>, url: string) => {
        const { searchExtended } = getGlobals().routes;

        if (!searchExtended || getPathname(url) !== getPathname(searchExtended)) {
            return;
        }

        // Let the browser handle new-tab / modified clicks so we don't hijack them.
        if (!isPlainLeftClick(event) || loadViewMode() !== ViewMode.Table) {
            return;
        }

        event.preventDefault();
        router.push(`${url}?${SearchQueryParams.View}=${ViewMode.Table}`);
    };

    return { handleSearchLinkClick };
};
